import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-end',
  flexWrap: 'wrap',
  width: '100%'
}));

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'end',
  gap: 16,
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'nowrap',
  marginTop: 8,
  '@media (max-width: 600px)': {
    flexDirection: 'column'
  }
}));

export const HeaderWrapper = styled(Box)(() => ({
  maxWidth: '95%',
  marginInline: 'auto'
}));

export const RoundedButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: '100%',
  whiteSpace: 'nowrap',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto'
  }
});
